// ServicesData.js

import TreeCut           from '../services/images/pexels-canvastudio-3194518.jpg';
import TreeRemoval       from '../services/images/pexels-tima-miroshnichenko-9574569.jpg';
import TreeStump         from '../services/images/pexels-format-380633-1029757.jpg';
import TreeStorm         from '../services/images/Lead Generation.jpg';
import PoolImage         from '../services/images/pexels-heyho-8134750.jpg';
import PlumbingImage         from '../services/images/plumbing.png';
import ContractImage     from '../services/images/general-contracting.jpg';
import RoofingImage      from '../services/images/roofing.jpg';
import SolarElectricImage from '../services/images/SolarElectric.jpg';

const ServicesData = [
  /*  {
        title: 'Website Development and Applications',
        description: `
Clubhouse Links is your best choice for web application and website development projects. We build fast, secure, and visually striking platforms tailored to your exact needs. From interactive React/SPAs to robust serverless backends, our solutions scale with your business. Every project starts with wireframes and style guides that reflect your brand’s personality.

Beyond design, we implement continuous integration pipelines, ensure accessibility compliance, and embed analytics for data-driven growth. Our ongoing maintenance and performance tuning keep your site running flawlessly—and our SEO optimizations help you climb search rankings over time.
    `,
        image: TreeCut,
    },
    {
        title: 'Design and Apparel',
        description: `
At Clubhouse Links, we harness the power of A.I. and human creativity to design custom apparel with unmatched speed and precision. From concept sketches to full-color mockups, our mockup generator lets you visualize every detail—fabric, cut, and color palette—before production.

Implementation is equally turnkey: we prep print-ready files, manage your sublimation and embroidery runs, and coordinate fulfillment. Whether you need sports uniforms, corporate swag, or fashion lines, we deliver a seamless end-to-end apparel solution.
    `,
        image: TreeRemoval,
    },
    {
        title: 'Graphic Design',
        description: `
Clubhouse Links delivers bold, high-impact graphic design that brings brands to life. We begin with a deep dive into your story and audience, then craft mood boards and style tiles. Our designers iterate on logos, icons, and layouts until every asset captures your unique voice.

When it’s time to implement, we package your brand into comprehensive style guides, provide print-ready files for signage and collateral, and hand off digital assets optimized for web, mobile, and social. Consistency across every channel is our promise.
    `,
        image: TreeStump,
    },
    {
        title: 'Lead Services',
        description: `
We provide turnkey lead-generation through custom CRM integrations and API extensions. By targeting HOAs, municipal contracts, and hyper-local communities like Nextdoor, you’ll build a steady pipeline of qualified prospects. Each campaign is designed with conversion-focused landing pages and drip-email sequences.

Implementation includes dashboard design for real-time visibility, automated workflows that route new leads to your sales team, and A/B testing to continuously refine messaging. Data-driven reports ensure you see exactly which channels deliver the best ROI.
    `,
        image: TreeStorm,
    },*/
    {
        title: 'Pool Remodeling and Cleaning',
        description: `
Dream it. We’ll design it. Clubhouse Links starts every pool remodeling project with 3D renderings and material selections, from tile mosaics to LED color-wash lighting. Our concept designs ensure that every curve, spillway, and deck finish complements your backyard oasis.

When it comes to implementation, we manage the entire process: demolition of old surfaces, installation of new liners or plaster, mechanical upgrades, and ongoing cleaning schedules. We even integrate smart-pump systems and automated chemical dosing to keep your water crystal clear.
    `,
        image: PoolImage,
    },
    {
        title: 'Plumbing and Handyman Services',
        description: `
We'll provide you with great value at minimal cost with our plumbing and handyman services. All technicians are licensed and have been thoroughly vetted.
Whether it's a leaky faucet or a garbage disposal removal, we'll make sure it's done right.
    `,
        image: PlumbingImage,
    },
    {
        title: 'General Contracting',
        description: `
As a full-service design firm, Clubhouse Links can architect and plan nearly any build. We produce detailed blueprints, interior layouts, and finish schedules that align with your vision—whether it’s a retail space, office renovation, or custom home extension.

On the implementation side, we act as your single point of accountability: securing permits, vetting subcontractors, managing site logistics, and enforcing quality control. From groundbreaking to ribbon-cutting, we ensure the final construction perfectly matches the approved designs.
    `,
        image: ContractImage,
    },
    {
        title: 'Roofing',
        description: `
Roofing is about more than shingles—it’s about protection and curb appeal. Our designers work with you to select materials (metal, asphalt, tile) and colors that harmonize with your architecture while maximizing energy efficiency and drainage performance.

Implementation covers full tear-off or overlay, installation of high-grade underlayment, flashing, ridge vents, and smart-tile integration for future solar readiness. We adhere strictly to manufacturer specs and local code, so you end up with a roof that’s built to last.
    `,
        image: RoofingImage,
    },
    {
        title: 'Solar & Electric Utility Steam-lined Implementation',
        description: `
Clubhouse Links designs solar arrays that meet both aesthetic and performance goals. We create site plans, electrical schematics, and 3D panel layouts that integrate seamlessly with your roof or ground-mount system. Every design balances shade analysis, optimal tilt, and your grid-tie requirements.

For implementation, we handle permitting, panel and inverter installation, battery storage integration, and utility interconnection. We also build custom monitoring dashboards so you can track energy production in real time—and ensure your installation delivers maximum savings year after year.
    `,
        image: SolarElectricImage,
    },
];

export default ServicesData;
